import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Popover from 'react-awesome-popover';
import config from '../../../config/config.js';
import axios from 'axios';
import Select2 from 'react-select2-wrapper';
import {connect} from "react-redux";

class EditLocation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            description: '',
            place: '',
            contactPerson: '',
            phone: '',
            equipment: '',
            specialInformation: '',
            gridSquare: '',
            selfServiceInformation: '',
            workType: '',
            availableWorkTypes: [],
            company: '',
            latitude: '',
            longitude: '',
            open: false,
            editing: false,
            loading: false,
            errors: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadLocation = this.loadLocation.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleStartEditing = this.handleStartEditing.bind(this);
        this.handleCancelEditing = this.handleCancelEditing.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleOpen() {
        this.setState({
            open: true,
            errors: [],
            name: '',
            description: '',
            place: '',
            contactPerson: '',
            phone: '',
            equipment: '',
            specialInformation: '',
            workProtection: '',
            gridSquare: '',
            selfServiceInformation: '',
            workType: '',
            availableWorkTypes: [],
            company: '',
            latitude: '',
            longitude: '',
            editing: false
        });
        this.loadLocation();
    }

    handleClose() {
        this.setState({
            name: '',
            description: '',
            place: '',
            contactPerson: '',
            phone: '',
            equipment: '',
            specialInformation: '',
            workProtection: '',
            gridSquare: '',
            selfServiceInformation: '',
            workType: '',
            availableWorkTypes: [],
            company: '',
            latitude: '',
            longitude: '',
            open: false,
            errors: [],
            editing: false
        });
        this.props.handleClose();
    }

    loadLocation() {
        let that = this;
        axios(config.server.endpoint + 'backend/location/' + this.props.id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    open: true,
                    name: response.data.name,
                    description: response.data.description,
                    place: response.data.place,
                    contactPerson: response.data.contactPerson,
                    phone: response.data.phone,
                    equipment: response.data.equipment,
                    specialInformation: response.data.specialInformation,
                    workProtection: response.data.workProtection,
                    gridSquare: response.data.gridSquare,
                    selfServiceInformation: response.data.selfServiceInformation,
                    workType: response.data.workType,
                    availableWorkTypes: response.data.availableWorkTypes,
                    company: response.data.company,
                    latitude: response.data.latitude,
                    longitude: response.data.longitude,
                });
            }
        });
    }

    handleSave() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/location/' + that.props.id, {
            method: 'put',
            data: {
                name: that.state.name,
                description: that.state.description,
                place: that.state.place,
                contactPerson: that.state.contactPerson,
                phone: that.state.phone,
                equipment: that.state.equipment,
                specialInformation: that.state.specialInformation,
                workProtection: that.state.workProtection,
                gridSquare: that.state.gridSquare,
                selfServiceInformation: that.state.selfServiceInformation,
                workType: that.state.workType,
                company: that.state.company,
                latitude: that.state.latitude,
                longitude: that.state.longitude
            }
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    loading: false,
                    editing: false
                });
                if(response.data.success === true) {
                    that.handleClose();
                } else {
                    that.setState({
                        errors: response.data.errors
                    });
                }
            }
        });
    }

    handleStartEditing() {
        this.setState({
            editing: true
        });
    }

    handleCancelEditing() {
        this.setState({
            editing: false
        });
        this.loadLocation();
    }

    render() {
        const { t } = this.props;
        return (
            <Popover targetClass="m-l-xs" onOpen={this.handleOpen} onClose={this.handleClose} open={this.state.open} contentClass="rap-popover-content">
                <a ref="target">
                    <i className="fa fa-external-link"/>
                </a>
                <div className="p-md EditLocationPopover" style={{width: 900, textAlign: 'left'}}>
                    <div className="row">
                        <div className="col-xs-6">
                            <div
                                className="form-group">
                                <label>{t('location.name.label')}</label>
                                <input type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.name) ? (
                                    <span className="help-block">
                                {t('location.name.error.' + this.state.errors.name)}
                            </span>
                                ) : null}
                            </div>
                            <div
                                className="form-group">
                                <label>{t('location.description.label')}</label>
                                <textarea name="description" className="form-control" value={this.state.description ? this.state.description : null} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.description) ? (
                                    <span className="help-block">
                                {t('location.description.error.' + this.state.errors.description)}
                            </span>
                                ) : null}
                            </div>
                            <div
                                className="form-group">
                                <label>{t('location.contactPerson.label')}</label>
                                <input type="text" name="contactPerson" className="form-control" value={this.state.contactPerson} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.contactPerson) ? (
                                    <span className="help-block">
                                {t('location.contactPerson.error.' + this.state.errors.contactPerson)}
                            </span>
                                ) : null}
                            </div>
                            <div
                                className="form-group">
                                <label>{t('location.phone.label')}</label>
                                <input type="text" name="phone" className="form-control" value={this.state.phone} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.contactPerson) ? (
                                    <span className="help-block">
                                {t('location.phone.error.' + this.state.errors.phone)}
                            </span>
                                ) : null}
                            </div>
                            <div
                                className="form-group">
                                <label>{t('location.gridSquare.label')}</label>
                                <input type="text" name="gridSquare" className="form-control" value={this.state.gridSquare} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.gridSquare) ? (
                                    <span className="help-block">
                                {t('location.gridSquare.error.' + this.state.errors.gridSquare)}
                            </span>
                                ) : null}
                            </div>
                            <div
                              className="form-group">
                                <label>{t('location.selfServiceInformation.label')}</label>
                                <input type="text" name="selfServiceInformation" className="form-control"
                                       value={this.state.selfServiceInformation} onChange={this.handleInputChange}
                                       readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.selfServiceInformation) ? (
                                  <span className="help-block">
                                {t('location.selfServiceInformation.error.' + this.state.errors.selfServiceInformation)}
                            </span>
                                ) : null}
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-lg-6">
                                    <div
                                        className="form-group">
                                        <label>{t('location.latitude.label')}</label>
                                        <input type="text" name="latitude" className="form-control" value={this.state.latitude} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                        {(this.state.errors && this.state.errors.latitude) ? (
                                            <span className="help-block">
                                                {t('location.latitude.error.' + this.state.errors.latitude)}
                                            </span>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-lg-6">
                                    <div
                                        className="form-group">
                                        <label>{t('location.longitude.label')}</label>
                                        <input type="text" name="longitude" className="form-control" value={this.state.longitude} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                        {(this.state.errors && this.state.errors.longitude) ? (
                                            <span className="help-block">
                                                {t('location.longitude.error.' + this.state.errors.longitude)}
                                            </span>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <div
                                className="form-group">
                                <label>{t('location.place.label')}</label>
                                <input type="text" name="place" className="form-control" value={this.state.place} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.place) ? (
                                    <span className="help-block">
                                {t('location.place.error.' + this.state.errors.place)}
                            </span>
                                ) : null}
                            </div>
                            <div
                                className="form-group">
                                <label>{t('location.equipment.label')}</label>
                                <textarea name="equipment" className="form-control" value={this.state.equipment} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.equipment) ? (
                                    <span className="help-block">
                                {t('location.equipment.error.' + this.state.errors.equipment)}
                            </span>
                                ) : null}
                            </div>
                            <div
                                className="form-group">
                                <label>{t('location.specialInformation.label')}</label>
                                <textarea name="specialInformation" className="form-control" value={this.state.specialInformation} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.specialInformation) ? (
                                    <span className="help-block">
                                {t('location.specialInformation.error.' + this.state.errors.specialInformation)}
                            </span>
                                ) : null}
                            </div>
                            <div
                                className="form-group">
                                <label>{t('location.workProtection.label')}</label>
                                <textarea name="workProtection" className="form-control" value={this.state.workProtection} onChange={this.handleInputChange} readOnly={!this.state.editing}/>
                                {(this.state.errors && this.state.errors.workProtection) ? (
                                    <span className="help-block">
                                {t('location.workProtection.error.' + this.state.errors.workProtection)}
                            </span>
                                ) : null}
                            </div>
                            <div
                                className="form-group">
                                <label>{t('location.workType.label')}</label>
                                <Select2 data={this.state.availableWorkTypes.map((el) => {
                                    return {
                                        text: t('default.workType.' + el), id: el
                                    }
                                })} value={this.state.workType} onChange={this.handleInputChange} name="workType"
                                         options={{placeholder: t('location.workType.placeholder'), disabled: !this.state.editing}}
                                         className="width-100p block"/>
                                {(this.state.errors && this.state.errors.workType) ? (
                                    <span className="help-block">
                                {t('location.workType.error.' + this.state.errors.workType)}
                            </span>
                                ) : null}
                            </div>
                            <div
                                className="form-group">
                                <label>{t('location.company.label')}</label>
                                <Select2 data={this.props.company.companies.filter(c => c.projects.find(pId => pId ===this.props.project.selectedProject.id)).map((el) => {
                                    return {
                                        text: el.name, id: el.id
                                    }
                                })} value={this.state.company} onChange={this.handleInputChange} name="company"
                                         options={{placeholder: t('location.company.placeholder'), disabled: !this.state.editing, allowClear: true}}
                                         className="width-100p block"/>
                                {(this.state.errors && this.state.errors.company) ? (
                                    <span className="help-block">
                                {t('location.company.error.' + this.state.errors.company)}
                            </span>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    {!this.state.editing ? (
                        <div className="btn-group">
                            <button className="btn btn-small btn-primary" onClick={this.handleStartEditing}>
                                <i className="fa fa-pencil m-r-sm"/>
                                {t('default.edit')}
                            </button>
                            <button className="btn btn-small btn-default" onClick={this.handleClose}>
                                <i className="fa fa-close m-r-sm"/>
                                {t('default.close')}
                            </button>
                        </div>
                    ) : (
                        <div className="btn-group">
                            <button className="btn btn-small btn-default" onClick={this.handleCancelEditing}>
                                <i className="fa fa-trash m-r-sm"/>
                                {t('default.cancel')}
                            </button>
                            <button className="btn btn-small btn-primary" onClick={this.handleSave}>
                                <i className="fa fa-save m-r-sm"/>
                                {t('default.save')}
                            </button>
                        </div>
                    )}

                </div>
            </Popover>
        )
    }
}

const mapStateToProps = state => {
    return {
        project: state.project,
        scope: state.scope,
        company: state.company
    }
};

export default connect(mapStateToProps, {

})(translate()(EditLocation));
